import { serverReportError } from '#app/lib/error'
import preq from '#app/lib/preq'
import { searchWikidataEntities } from '#app/lib/wikimedia/wikidata'
import type { WdEntityUri } from '#server/types/entity'
import { getCurrentLang } from '#user/lib/i18n'
import type { SearchResponse, SearchResult } from 'wikibase-sdk'
import type { SearchResult as _RawWdSearchResult } from 'wikibase-sdk'

export type RawWdSearchResult = _RawWdSearchResult

// Uses wbsearchentities despite its lack of inter-languages support
// because it returns hits labels, descriptions and aliases
// while action=query&list=search&srsearch returns only hits ids
export async function wikidataSearch ({ search, limit = 10, offset }) {
  const res = await preq.get(searchWikidataEntities({ search, limit, offset }))
  let { search: results, 'search-continue': continu } = res as SearchResponse
  if (results) {
    results = results.filter(filterOutSpecialPages)
  } else {
    serverReportError('wikidata search returned no results', { search, res })
    results = []
  }
  return { results, continue: continu }
}

export async function wikidataFormattedSearch ({ search, limit = 10, offset }) {
  const { results, continue: continu } = await wikidataSearch({ search, limit, offset })
  return {
    results: results.map(formatAsSearchResult),
    continue: continu,
  }
}

// This is a hacky way to filter out special pages without having to request claims
const specialPagesDescriptionPattern = /(Wikim(e|é)dia|Wikip(e|é)dia)/
function filterOutSpecialPages (result: SearchResult) {
  result.description = result.description || ''
  return !result.description.match(specialPagesDescriptionPattern)
}

// make the result match the needs of #search/components/search_result.svelte
function formatAsSearchResult (result: RawWdSearchResult) {
  const lang = getCurrentLang()
  const { id, label, description, aliases } = result
  return {
    uri: `wd:${id}` as WdEntityUri,
    label,
    labels: {
      [lang]: label,
    },
    description,
    descriptions: {
      [lang]: description,
    },
    aliases: {
      [lang]: aliases,
    },
  }
}
